import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchOperations(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/ExpedientesDigitales/Operaciones', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDownloadAllDigitalRecords(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/ExpedientesDigitales/Operaciones/Descarga', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
